import { useEffect, useState, useCallback } from "react";
import { IoSearchOutline } from "react-icons/io5";
import { CiBellOn } from "react-icons/ci";
import { FaRegUser } from "react-icons/fa";
import { debounceFunction } from "../../utils";

const SearchBox = ({
  placeholder = "Search...",
  value,
  onChange,
  onRightIcon1Click,
  onRightIcon2Click,
  className = "",
}) => {
  const [search, setSearch] = useState("");

  const onChangeHandler = debounceFunction(onChange, 500)

  useEffect(() => {
    setSearch(value)
  }, [value])

  return (
    <div className={`search-box-container ${className}`}>
      <div className="w-100">
        <span className="search-box-icon left"><IoSearchOutline fontSize={20} /></span>
        <input
          type="text"
          className="input-box"
          placeholder={placeholder}
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            onChangeHandler(e);
          }}
        />
      </div>
      <div className="right-icon d-flex justify-content-around align-items-center">
        <div className="ms-3" onClick={onRightIcon1Click}>
          <CiBellOn fontSize={24} />
        </div>

        <div className="" onClick={onRightIcon2Click}>
          <FaRegUser fontSize={20} />
        </div>
      </div>
    </div>
  );
};

export default SearchBox;